import { FetchConsolidationOrganisationInfoResult } from '../queries/consolidations';
import { FetchWorkspacesListingResult } from '../operations/workspaces/queries/workspacesListingQuery';
import { SubEntityForecastsResult } from '../queries/consolidatedForecasts';

import { consolidationOrganisationDataCombiner } from './consolidationOrganisationDataCombiner';
import { ConsolidationSubEntityForecastsSubEntityItem } from '@futrli-sdk/consolidations';

export type CombinedSubEntityForecastData = Record<
  string,
  ConsolidationSubEntityForecastsSubEntityItem & { name: string }
>;

export const subEntityForecastsCombiner = (
  subEntityForecasts: SubEntityForecastsResult | undefined,
  workspaceListing: FetchWorkspacesListingResult | undefined,
  consolidationOrganisationInfo: FetchConsolidationOrganisationInfoResult | undefined,
  workspaceId: string
) => {
  if (!subEntityForecasts || !workspaceListing || !consolidationOrganisationInfo) {
    return undefined;
  }
  const orgData = consolidationOrganisationDataCombiner(workspaceListing, consolidationOrganisationInfo, workspaceId);
  const output: CombinedSubEntityForecastData = {} as CombinedSubEntityForecastData;

  Object.keys(subEntityForecasts.organisations).forEach(orgId => {
    output[orgId] = {
      ...subEntityForecasts.organisations[orgId],
      name: orgData?.[orgId]?.name || ''
    };
  });

  return output;
};
